import { Progress, Text } from "@mantine/core";
import React from "react";
import { OtAttempt2 } from "./PositionStats";
import { EQUALIBRIUM, MISTAKE_DELTA } from "./utils";
import cn from "classnames";

interface Props {
    attempts: OtAttempt2[];
    playerColor: string;
}

const ProgressBar: React.FC<Props> = ({ attempts, playerColor }) => {
    const advantagePositions = attempts.filter((attempt) => {
        if (playerColor === "w") {
            return parseFloat(attempt.evaluation) >= EQUALIBRIUM + MISTAKE_DELTA;
        }
        if (playerColor === "b") {
            return parseFloat(attempt.evaluation) <= EQUALIBRIUM - MISTAKE_DELTA;
        }
    });
    const disadvantagePositions = attempts.filter((attempt) => {
        if (playerColor === "w") {
            return parseFloat(attempt.evaluation) <= EQUALIBRIUM - MISTAKE_DELTA;
        }
        if (playerColor === "b") {
            return parseFloat(attempt.evaluation) >= EQUALIBRIUM + MISTAKE_DELTA;
        }
    });
    const equalPositions = attempts.filter(
        (attempt) =>
            parseFloat(attempt.evaluation) > EQUALIBRIUM - MISTAKE_DELTA &&
            parseFloat(attempt.evaluation) < EQUALIBRIUM + MISTAKE_DELTA
    );

    const total = attempts.length;
    const advantage = (advantagePositions.length / total) * 100;
    const disadvantage = (disadvantagePositions.length / total) * 100;
    const equal = (equalPositions.length / total) * 100;

    return (
        <div className="relative">
            <Progress.Root styles={{ root: { overflow: "visible" } }} size="xl" mx="lg">
                <Progress.Section
                    className="relative"
                    styles={{ section: { overflow: "visible" } }}
                    value={advantage}
                    color="green"
                >
                    <Text fz="h2" fw="bold" c="green" className="absolute bottom-4 left-0  font-bold">
                        {`${Math.round(advantage)}%`}
                    </Text>
                    <Text fz="sm" c="green" className="absolute top-6 left-0  font-bold">
                        {advantagePositions.length} Advantage
                    </Text>
                </Progress.Section>
                <Progress.Section
                    className="relative"
                    styles={{ section: { overflow: "visible" } }}
                    value={equal}
                    color="silver"
                >
                    <Text
                        fz="h2"
                        fw="bold"
                        className={cn("absolute bottom-4 font-bold", {
                            "left-20": advantage === 0,
                            "right-20": disadvantage === 0,
                        })}
                    >
                        {`${Math.round(equal)}%`}
                    </Text>
                    <Text
                        fz="sm"
                        className={cn("absolute top-6 font-bold", {
                            "left-20": advantage === 0,
                            "right-20": disadvantage === 0,
                        })}
                    >
                        {equalPositions.length} Equal
                    </Text>
                </Progress.Section>

                <Progress.Section value={disadvantage} styles={{ section: { overflow: "visible" } }} color="red">
                    <Text fz="h2" fw="bold" c="red" className="absolute bottom-4 right-0 font-bold">
                        {`${Math.round(disadvantage)}%`}
                    </Text>
                    <Text fz="sm" c="red" className="absolute top-6 right-0 font-bold">
                        {disadvantagePositions.length} Disadvantage
                    </Text>
                </Progress.Section>
            </Progress.Root>
        </div>
    );
};

export default ProgressBar;
